// Write your code here
import './index.css'
import {format} from 'date-fns'

const AppointmentItem = props => {
  const {eachApp, changeStatusOfImp, key} = props
  const {userAppoimentName, appoimentDate, id, importantAppoiment} = eachApp
  const appDate = format(new Date(appoimentDate), 'dd MMMM yyyy, EEEE')

  const capitalizedText = userAppoimentName.toUpperCase()

  const onClickStatus = () => {
    changeStatusOfImp(id)
  }
  const statusOfStart = importantAppoiment
    ? 'https://assets.ccbp.in/frontend/react-js/appointments-app/filled-star-img.png'
    : 'https://assets.ccbp.in/frontend/react-js/appointments-app/star-img.png'
  return (
    <div className="each-app-container">
      <li className="list-sty" key={key}>
        <div className="align-container">
          <p className="app-name-sty">{capitalizedText}</p>
          <button type="button" className="str-btn" onClick={onClickStatus}>
            <img src={statusOfStart} alt="star" className="str-sty" />
          </button>
        </div>
        <p className="time-sty">{appDate}</p>
      </li>
    </div>
  )
}

export default AppointmentItem
